// Independent of CRM_ENABLED so the internal pilot can coexist with legacy screens.
export const pipedriveAppEnabled = () =>
  process.env.REACT_APP_PIPEDRIVE_APP_ENABLED === undefined ||
  process.env.REACT_APP_PIPEDRIVE_APP_ENABLED === 'true';
